
const digest = '8bedcd5d6b80ba66999bc06f5c1a22c78e0fb354956c009a7c625b56be2d3898';
const classes = {"wrapper":"_wrapper_p1wt9_1","title":"_title_p1wt9_10","maxContent":"_maxContent_p1wt9_16","optional":"_optional_p1wt9_20"};
const css = `._wrapper_p1wt9_1 {
  font-family: Rubik, sans-serif;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

._title_p1wt9_10 {
  color: #3e3f42;
  font-weight: 400;
  font-size: 14px;
}

._maxContent_p1wt9_16 {
  width: max-content;
}

._optional_p1wt9_20 {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #909090;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  